import { Avatar as MuiAvatar } from "@mui/material";
import React from "react";

import { getStringInitials, stringToColor } from "@utils";

const Avatar = ({ variant, name, size, fontSize, sx = {}, ...rest }) => (
  <MuiAvatar
    variant={variant}
    sx={{ width: size, height: size, fontSize, bgcolor: stringToColor(name), ...sx }}
    {...rest}
  >
    {getStringInitials(name, 2)}
  </MuiAvatar>
);

export default Avatar;
